import axios from 'axios';
import { formatApiError } from '../utils/apiError';
import { API_BASE_URL } from '../config/apiConfig';

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token and handle FormData
api.interceptors.request.use(
  (config) => {
    // Add auth token from localStorage (fallback if not in defaults)
    const token = localStorage.getItem('token');
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // If sending FormData, set Content-Type to undefined to let browser set it with boundary
    if (config.data instanceof FormData) {
      config.headers['Content-Type'] = undefined;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor:
//   1. On 401: drop the local token and bounce to /login (existing behavior).
//   2. Always overwrite the rejected error's `.message` with a user-friendly
//      string derived from the canonical { success:false, error, message,
//      details } envelope. Existing onError handlers reading `error.message`
//      automatically get useful text instead of "Request failed with status
//      code 400". Per-field details remain on `error.response.data.details`
//      for forms that want inline highlighting (use fieldErrorsFromApiError).
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    try {
      const friendly = formatApiError(error);
      if (friendly) {
        error.message = friendly;
      }
    } catch {
      // Don't let formatting failures swallow the original error.
    }
    return Promise.reject(error);
  }
);

export default api;
